import { BirthdateInputUnionType } from '../../../common';

type GetShouldFocusNextFieldArgsType = {
  inputValue: string;
  inputType: BirthdateInputUnionType;
};

export const getShouldFocusNextField = ({
  inputValue,
  inputType,
}: GetShouldFocusNextFieldArgsType): boolean => {
  switch (inputType) {
    case 'DAY':
      return inputValue.length === 2;
    case 'MONTH':
      return inputValue.length === 2;
    case 'YEAR':
      return inputValue.length === 4;
  }
};
